(function () {
    //Format currency
    angular.module('tmx-app').filter('tmxCurrency', ['$filter', function ($filter) {
        return function (value, currency, maxfractionLength, frationIncludeAlways) {
            //if value not number return value
            if(!(!isNaN(parseFloat(value)) && isFinite(value))) return value;
            if (!currency) currency = '';
            if (!maxfractionLength) maxfractionLength = 3;
            if (!frationIncludeAlways) frationIncludeAlways = false;
            value = parseFloat(value);
            if (frationIncludeAlways) {
                value = value.toFixed(maxfractionLength);
            }
            return currency + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        };
    }]);

})();